import Tab from './tab'
import TabItem from './tab-item'

export {
  Tab,
  TabItem
}



// WEBPACK FOOTER //
// ./~/.0.1.3@vux/src/components/tab/index.js